import { API } from "@/lib/api";

let current = null;
let seq = 0;

export function stopVoice() {
  seq += 1;
  if (current) {
    current.pause();
    current = null;
  }
  window.speechSynthesis?.cancel();
}

function browserVoice(text, onEnd) {
  if (!window.speechSynthesis) return onEnd?.(false);
  const u = new SpeechSynthesisUtterance(text);
  u.lang = "it-IT";
  const it = window.speechSynthesis.getVoices().filter((v) => v.lang?.startsWith("it"));
  u.voice = it.find((v) => /natural|online|google/i.test(v.name)) || it[0] || null;
  u.onend = () => onEnd?.(true);
  u.onerror = () => onEnd?.(false);
  window.speechSynthesis.speak(u);
}

// ElevenLabs (natural Italian voice) with browser voice fallback.
export async function playVoice(text, onEnd) {
  stopVoice();
  const my = seq;
  if (!text?.trim()) return onEnd?.(true);
  try {
    const res = await fetch(`${API}/tts`, {
      method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text: text.slice(0, 1200) }),
    });
    if (!res.ok) throw new Error("tts");
    const blob = await res.blob();
    if (my !== seq) return undefined;
    const audio = new Audio(URL.createObjectURL(blob));
    current = audio;
    audio.onended = () => onEnd?.(true);
    audio.onerror = () => onEnd?.(false);
    await audio.play();
  } catch {
    if (my === seq) browserVoice(text, onEnd);
  }
}
